import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _mb-3" }
const _hoisted_3 = { class: "_flex _jc-sb _fd-c _fd-r--m" }
const _hoisted_4 = { class: "_mt-0" }
const _hoisted_5 = { class: "_flex _jc-sb _ai-c _shrink-0" }
const _hoisted_6 = { class: "_flex _jc-sb _fd-c _fd-r--m" }
const _hoisted_7 = { class: "_mt-0" }
const _hoisted_8 = { class: "_flex _jc-sb _ai-c _shrink-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_option_field = _resolveComponent("option-field")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_base_title, { as: "h2" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.ProjectNotificationHeader), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.SubscriptionManagement.ProjectNotificationDescription), 1 /* TEXT */),
        ($options.isEnablePushNotificationsMessageVisible)
          ? (_openBlock(), _createBlock(_component_base_notificator, {
              key: 0,
              class: "_mb-3",
              "can-close": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushEnableParagraph), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "_pa-0 _mx-1 _tdu",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onNotificationHide && $options.onNotificationHide(...args))),
                      "data-qa": "push-notification:HideThisMessage"
                    }, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushHideLabel), 1 /* TEXT */),
                    _createVNode(_component_base_button, {
                      class: "_ml-a",
                      theme: "transparentInverse",
                      onClick: $options.onActivatePushNotifications,
                      "data-qa": "push-notification:Activate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushActivateLabel), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($options.isPushNotificationsBlockedByBrowserMessageVisible)
          ? (_openBlock(), _createBlock(_component_base_notificator, {
              key: 1,
              class: "_mb-3",
              "can-close": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushBlockedByBrowserParagraph), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "_pa-0 _mx-1 _tdu",
                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.onNotificationHide && $options.onNotificationHide(...args))),
                      "data-qa": "push-notification:HideThisMessage"
                    }, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushHideLabel), 1 /* TEXT */),
                    _createVNode(_component_base_button, {
                      class: "_ml-a",
                      theme: "transparentInverse",
                      tag: "a",
                      href: $options.browserHelpUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: $options.onBrowserHelpButtonClick,
                      "data-qa": "push-notification:ReadInstructions"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushHowToUnblockLink), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href", "onClick"])
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_option_field, {
          modelValue: _ctx.model.projectMilestones,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = $event => ((_ctx.model.projectMilestones) = $event)),
            $options.onProjectMilestonesNotificationPreferenceChange
          ],
          "first-column-width": 8,
          options: $setup.notificationPreferenceOptions,
          "display-name": _ctx.Resources.SubscriptionManagement.ProjectMilestonesFieldLabel,
          name: "model.projectMilestones",
          layout: "columns",
          class: "_mb-3",
          description: _ctx.Resources.SubscriptionManagement.ProjectMilestonesInputFieldDescription,
          "data-qa": "general-notifications:General"
        }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
        _createVNode(_component_option_field, {
          modelValue: _ctx.model.projectUpdates,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = $event => ((_ctx.model.projectUpdates) = $event)),
            $options.onProjectUpdatesNotificationPreferenceChange
          ],
          "first-column-width": 8,
          options: $setup.notificationPreferenceOptions,
          "display-name": _ctx.Resources.SubscriptionManagement.ProjectUpdatesFieldLabel,
          name: "model.projectUpdates",
          layout: "columns",
          class: "_mt-0",
          description: _ctx.Resources.SubscriptionManagement.ProjectUpdatesInputFieldDescription,
          "data-qa": "general-notifications:Updates"
        }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}